export const LangTexts = {
  en: {
    errorMessage: 'Something has gone wrong',
    errorAction: 'GO BACK',
    born: 'Born:',
    noBiography: 'Sorry, no biography yet ...:',
    actorMovies: 'Casted on',
    noActorMovies: 'Sorry nothing was found',
  },
  'pt-BR': {
    errorMessage: 'Ocorreu algo de Errado',
    errorAction: 'VOLTAR',
    born: 'Nascido:',
    noBiography: 'Desculpe, não foi encontrado uma biografia ...',
    actorMovies: 'Também atuou em',
    noActorMovies: 'Desculpe, nada foi encontrado',
  },
};
